import { resolveCtoDateSelectionMaxDays } from "../utils/vesselsRules";
import { useFeatureFlag } from "./useFeatureFlag";

export const useCtoDateSelectionMaxDays = (
  vesselId: string | null | undefined,
) => {
  const extendedRangeEnabled = useFeatureFlag(
    "cto-date-selection-365-days",
  );

  return resolveCtoDateSelectionMaxDays(vesselId, extendedRangeEnabled);
};
